function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Services = function Services(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M15.54 10.46c-.41 0-.75-.34-.75-.75V6.68h-3.03c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.03V2.16c0-.41.34-.75.75-.75s.75.34.75.75v3.02h3.02c.41 0 .75.34.75.75s-.34.75-.75.75h-3.02v3.03c0 .41-.34.75-.75.75M3.03 22.57h2.26a1.76 1.76 0 0 0 1.643-1.151c.996-.032 1.284.002 1.357.011.27.04.78.18 1.36.34 1.04.29 2.33.64 3.53.8.1.02.21.02.34.02v-.01c1.28 0 3.92-.64 5.43-1.63.03-.02 3.51-2.59 3.73-4.02.17-1.09-.15-1.99-.9-2.53-.864-.616-1.502-.492-2.314-.333l-.016.003c-.47.096-1.078.514-2.229 1.377-.067-.517-.316-1.04-.871-1.477-1.06-.83-5.62-1.61-6.97-1.19-.488.148-1.553.708-2.367 1.156A1.76 1.76 0 0 0 5.29 12.49H3.03c-.96 0-1.75.79-1.75 1.75v6.58c0 .96.79 1.75 1.75 1.75m4.01-6.927v4.276c1.094-.02 1.373.014 1.47.041.35.05.87.19 1.53.37l.146.04c.972.262 2.137.577 3.184.72.63.08 3.31-.43 4.76-1.38.77-.5 2.91-2.45 3.07-3.01.05-.34.04-.83-.3-1.08-.31-.23-.39-.23-1.16-.08-.26.08-1.21.79-1.77 1.22-.63.48-1.18.89-1.55 1.08q-1.095.57-1.98.57l-2.19-.21a.75.75 0 0 1-.67-.82c.04-.41.4-.72.82-.67l2.11.21c.213 0 .577-.108.989-.3l-.029-.02c.1-.15.58-.96-.04-1.45-.63-.49-4.64-1.23-5.6-.94-.42.137-1.838.898-2.79 1.433M2.78 14.24c0-.14.11-.25.25-.25h2.26c.14 0 .25.11.25.25v6.58c0 .14-.11.25-.25.25H3.03c-.14 0-.25-.11-.25-.25z",
    clipRule: "evenodd"
  }));
};
export default Services;
Services.displayName = 'Services';